import { TabsMenu as TabsMenuUI } from "artisn-ui-react";
import { useRouter } from "next/router";
import React from "react";

import Styles from "./ShopTabsMenuItem.styles";
import { ShopTabsMenuItemProps as Props } from "./ShopTabsMenuItem.types";
import useI18n from "hooks/useI18n";

import ShopSVG from "../../../../../public/assets/images/TabsMenu/shop.svg";

const { Item } = TabsMenuUI;

const ShopTabsMenuItem: React.FC<Props> = props => {
  const { className, hideTitle, active } = props;
  const { push } = useRouter();
  const t = useI18n();

  const onClickHandler = async () => {
    await push("/categories");
  };

  return (
    <Styles className={`ShopTabsMenuItem ${className}`} active={active}>
      <Item
        icon={ShopSVG}
        title={hideTitle ? undefined : t.navigation.shopping}
        onClick={onClickHandler}
      />
    </Styles>
  );
};

ShopTabsMenuItem.defaultProps = {
  className: ""
};

export default ShopTabsMenuItem;
